import { ISchema, PaywallComponentProps } from '../../../@types'
import { mergeDeep } from '@/helpers/utils'

type AnchorCopy = { title: string; anchorLabel: string }

const buildPriceAnchor = (anchor: AnchorCopy) => ({
	title: anchor.title,
	anchorPrice: '$75',
	anchorLabel: anchor.anchorLabel,
	planLabel: '/week',
})

const planPickerProps =
	(anchor: AnchorCopy) =>
	({ ctx, $t, $tc }): PaywallComponentProps.PlanPickerComp => ({
		items: [
			{
				title: {
					text: $tc('common.duration.week.dashed.uppercase', 1),
					uppercase: true,
				},
				price: {
					template: 'labeled-price',
					extras: {
						originalPrice: ctx.removeDiscount ? '' : '{original_trial_price}',
						dollars: '{trial_price_dollars}',
						cents: '{trial_price_cents}',
					},
				},
			},
			{
				title: {
					text: $tc('common.duration.week.dashed.uppercase', 4),
					uppercase: true,
				},
				subtitle: {
					text: ctx.removeDiscount ? '{price}' : '<s>{price}</s> {trial_price}',
					color: 'secondary',
				},
				price: {
					template: 'labeled-price',
					badge: ctx.removeDiscount
						? null
						: $t('pages.program.plan_picker.badge.percent_off_uppercase', { percent: ctx.discountPercent }),
					extras: {
						originalPrice: ctx.removeDiscount ? '' : '{original_trial_price_per_week_calculated}',
						dollars: ctx.removeDiscount ? '{price_per_week_dollars}' : '{trial_price_per_week_dollars}',
						cents: ctx.removeDiscount ? '{price_per_week_cents}' : '{trial_price_per_week_cents}',
						period: 'per week',
					},
				},
			},
			{
				title: {
					text: $tc('common.duration.week.dashed.uppercase', 12),
					uppercase: true,
				},
				badge: {
					text: $t('pages.program.cheap_and_short.common.planPicker.mostPopular'),
					uppercase: true,
				},
				subtitle: {
					text: ctx.removeDiscount ? '{price}' : '<s>{price}</s> {trial_price}',
					color: 'secondary',
				},
				price: {
					template: 'labeled-price',
					badge: ctx.removeDiscount
						? null
						: $t('pages.program.plan_picker.badge.percent_off_uppercase', { percent: ctx.discountPercent }),
					extras: {
						originalPrice: ctx.removeDiscount ? '' : '{original_trial_price_per_week_calculated}',
						dollars: ctx.removeDiscount ? '{price_per_week_dollars}' : '{trial_price_per_week_dollars}',
						cents: ctx.removeDiscount ? '{price_per_week_cents}' : '{trial_price_per_week_cents}',
						period: 'per week',
					},
				},
			},
		],
		bulletType: 'dot',
		priceAnchor: buildPriceAnchor(anchor),
	})

const anchors: AnchorCopy[] = [
	{
		title: 'A fraction of what you’d pay for one consultation with a nutritionist',
		anchorLabel: '/1 nutrition consultation',
	},
	{ title: 'Less than the cost of one private class', anchorLabel: '/1 private session' },
]

export default (schema: ISchema): ISchema => {
	let pickerIndex = 0

	return mergeDeep(
		{ ...schema },
		{
			order: schema.order.map((item) =>
				item === 'PaywallPlanPickerComp' ? ['PaywallPlanPickerComp', planPickerProps(anchors[pickerIndex++])] : item,
			),
		},
	)
}
